/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export const getPanel = stores => stores.bottomBoard.panelDropinId;
export const getPanelProps = stores => stores.bottomBoard.panelProps;
export const getBanner = stores => stores.bottomBoard.Banner;
export const getPanelVisiblity = stores => stores.bottomBoard.showPanel;
export const getBannerVisiblity = stores => stores.bottomBoard.showBanner;
// config items intendent to be used within views
export const getConfig = stores =>
  Object.keys(stores.bottomBoard.config).reduce((prev, curr) => {
    if (!filter.includes(curr)) {
      prev[curr] = stores.bottomBoard.config[curr];
    }
    return prev;
  }, {});
export const getRawConfig = stores => stores.bottomBoard.config;

// config items intendent to be used outside views
const filter = ["hideAndOpenOnLHP", "hideAndOpenOnRHP", "hideAndOpenOnZoom", "hideAndOpenOnScroll", "hideOnSelection"];

export const getIsPanelAutoHideEnabled = stores => getPanelVisiblity(stores) && stores.bottomBoard.enableAutoHideNShow;

export const getShouldShowProximityView = stores =>
  stores.bottomBoard.enableAutoHideNShow && stores.bottomBoard.showProximityView;

export const getBottomPanelRect = stores => stores.bottomBoard.bottomPanelRect;

export const getBottomBannerConfig = stores => stores.bottomBoard.bottomBannerConfig;

export const getShouldShowBottomBanner = stores => stores.bottomBoard.shouldShowBottomBanner;
